import React from 'react';
import GroupsIcon from '@mui/icons-material/Groups';
import EmailIcon from '@mui/icons-material/Email';
import PlaceIcon from '@mui/icons-material/Place';
import electedImage from "../assets/images/default/elected.jpg";

const ElectedOfficialsSection = () => {
    const officials = [
        {
            name: "Jean Rakotoarisoa",
            title: "Maire",
            photo: electedImage,
            email: "jean.rakoto@ambalavao.mg",
            bureau: "Hôtel de ville - 1er étage"
        },
        {
            name: "Marie Razanadrakoto",
            title: "Adjoint au Maire",
            photo: electedImage,
            email: "marie.razana@ambalavao.mg",
            bureau: "Hôtel de ville - RDC"
        },
        {
            name: "Andry Ravelomanana",
            title: "Conseiller Municipal",
            photo: electedImage,
            email: "andry.ravelo@ambalavao.mg",
            bureau: "Annexe Municipal"
        }
    ];

    return (
        <section className="bg-gray-900 py-24">
            <div className="max-w-7xl mx-auto px-4">
                {/* Header Section */}
                <div className="relative mb-20">
                    <div className="flex items-center justify-center mb-4">
                        <GroupsIcon sx={{fontSize: 40}} className="text-[#228B22]"/>
                    </div>
                    <h2 className="text-4xl md:text-5xl font-bold text-center text-white mb-6">
                        Les Élus de la <span className="text-[#228B22]">Commune</span>
                    </h2>
                    <div className="w-24 h-1 mx-auto bg-[#228B22]"/>
                </div>

                {/* Officials Section */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-16">
                    {officials.map((official, index) => (
                        <div key={index} className="group">
                            {/* Image Container */}
                            <div className="relative mb-6 perspective-1000">
                                <div
                                    className="relative h-[400px] transform transition-transform duration-500 group-hover:scale-105">
                                    <img
                                        src={official.photo}
                                        alt={official.name}
                                        className="h-full w-full object-cover"
                                    />
                                    {/* Overlay */}
                                    <div className="absolute inset-0 bg-gradient-to-t from-black/90 to-transparent"/>

                                    {/* Title Position */}
                                    <div className="absolute bottom-0 left-0 right-0 p-6">
                                        <h3 className="text-2xl font-bold text-white mb-2">{official.name}</h3>
                                        <span
                                            className="inline-flex px-3 py-1 bg-[#228B22]/20 text-[#228B22] rounded text-sm font-medium">
                      {official.title}
                    </span>
                                    </div>
                                </div>

                                {/* Decorative Corner Elements */}
                                <div
                                    className="absolute top-0 left-0 w-12 h-12 border-l-2 border-t-2 border-[#228B22] opacity-0 transition-opacity duration-300 group-hover:opacity-100"/>
                                <div
                                    className="absolute bottom-0 right-0 w-12 h-12 border-r-2 border-b-2 border-[#228B22] opacity-0 transition-opacity duration-300 group-hover:opacity-100"/>
                            </div>

                            {/* Contact Information */}
                            <div className="space-y-3 px-2">
                                <div
                                    className="flex items-center gap-3 text-zinc-300 hover:text-[#228B22] transition-colors duration-300">
                                    <EmailIcon sx={{fontSize: 20}} className="text-[#228B22]"/>
                                    <span className="text-sm">{official.email}</span>
                                </div>
                                <div
                                    className="flex items-center gap-3 text-zinc-300 hover:text-[#228B22] transition-colors duration-300">
                                    <PlaceIcon sx={{fontSize: 20}} className="text-[#228B22]"/>
                                    <span className="text-sm">{official.bureau}</span>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default ElectedOfficialsSection;